import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import media from '../../../utils/mediaQueries';

const Container = styled.div`
  padding: 0 40px;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  
  ${media.mobile`
    padding: 0;
  `}
`;

const NoAccessesLeft = ({ schoolPhone }) => (
  <Container>
    <span>L’achat des accès code en ligne est temporairement impossible. Pour pouvoir commencer la révision de votre code de la route, veuillez appeler l’auto-école au: </span>
    <a href={`tel:${schoolPhone}`}>{schoolPhone}</a>
    .
  </Container>
);

NoAccessesLeft.propTypes = {
  schoolPhone: PropTypes.string.isRequired,
};

export { NoAccessesLeft };
